/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Grid } from '@mairistem/composants';

import Divider from './Divider';

const GridColumnDivider = () => (
  <>
    <Grid.Column mobile={16} only="mobile">
      <Divider />
    </Grid.Column>
    <Grid.Column tablet={16} only="tablet">
      <Divider />
    </Grid.Column>
    <Grid.Column
      computer={1}
      only="computer"
      style={{
        display: 'flex',
        justifyContent: 'center',
        margin: 0,
      }}
    >
      <Divider vertical />
    </Grid.Column>
  </>
);

export default GridColumnDivider;
